<style scoped lang="less">
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <el-button size="mini" type="success" @click.stop="addOrEdit(null)">新增</el-button>
            <el-upload class="margin-l" ref="upload" action="" :on-change="selectFile" :auto-upload="false"
                :show-file-list="false">
                <el-button slot="trigger" size="mini" type="info" :loading="loading">导入</el-button>
            </el-upload>
            <el-button size="mini" class="margin-l" type="info" @click.stop="exportXlsx()">导出</el-button>
        </div>

        <paged-table :page-size="pageSize" ref="table" @fetch-data="fetchData" class="block-mini-top">
            <el-table slot :data="data" border size="mini" :cell-style="$parent.$parent.cellStyle">
                <el-table-column type="index" align="center" width="55">
                </el-table-column>
                <el-table-column label="生产商" align="center" prop="scs" width="60"></el-table-column>
                <el-table-column label="来源国" align="center" prop="lyg" width="80"></el-table-column>
                <el-table-column label="装货时间" align="center" width="90">
                    <template slot-scope="scope" v-if="scope.row.zhsj">
                        {{scope.row.zhsj | fmt-date}}
                    </template>
                </el-table-column>
                <el-table-column label="船名" align="center" prop="cm" width="160"></el-table-column>
                <el-table-column label="IMO" align="center" prop="imo" width="80"></el-table-column>
                <el-table-column label="区域" align="center" prop="qy" width="50"></el-table-column>
                <el-table-column label="省份" align="center" prop="sf" width="50"></el-table-column>
                <el-table-column label="到货港" align="center" prop="dhg" width="60"></el-table-column>
                <el-table-column label="库区" align="center" prop="kq" width="70"></el-table-column>
                <el-table-column label="社/M" align="center" prop="shkmto" width="50"></el-table-column>
                <el-table-column label="ETA" align="center" width="90">
                    <template slot-scope="scope">
                        {{scope.row.eta | fmt-date}}
                    </template>
                </el-table-column>
                <el-table-column label="到港" align="center" width="60">
                    <template slot-scope="scope" v-if="scope.row.eta">
                        {{calcYDWD(scope.row.eta)}}
                    </template>
                </el-table-column>
                <el-table-column label="数量" align="center" prop="amount" width="60"></el-table-column>
                <el-table-column label="收货人" align="center" prop="shr" width="80"></el-table-column>
                <el-table-column label="备注" align="center" prop="remarks" width="80"></el-table-column>

                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button class="super-mini-button" type="primary" size="mini"
                            @click.stop="addOrEdit(scope.row)">编辑</el-button>
                        <el-button class="super-mini-button" type="danger" size="mini"
                            @click.stop="removeModel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </paged-table>

        <dialog-edit-admin ref="edit" @fetch-data="fetchData"></dialog-edit-admin>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable";
import { HttpClient } from "../util/http.js";
import dayjs from "dayjs";
import DialogEditAdmin from "../components/dialog/dialogEditAdmin";
import { removeModel } from "../util/restful.js";
import { actionConfirm, msgSuccess } from "../util/toast.js";
import * as xlsx from "xlsx";
import { exportExcel } from "../util/exportExcel.js";

export default {
    components: {
        DialogEditAdmin,
        PagedTable,
    },
    mixins: [],
    data() {
        return {
            data: [],
            loading: false,
            pageSize: 1000,
        };
    },
    created() { },
    computed: {
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
    },
    mounted() { },
    methods: {
        async exportXlsx() {
            let list = this.data.map((it) => {
                return {
                    "生产商": it.scs ? it.scs : "",
                    "来源国": it.lyg ? it.lyg : "",
                    "装货时间": it.zhsj ? dayjs(it.zhsj).format("YYYY-MM-DD") : "",
                    "船名": it.cm ? it.cm : "",
                    "IMO": it.imo ? it.imo : "",
                    "区域": it.qy ? it.qy : "",
                    "省份": it.sf ? it.sf : "",
                    "到货港": it.dhg ? it.dhg : "",
                    "库区": it.kq ? it.kq : "",
                    "社会库/MTO": it.shkmto ? it.shkmto : "",
                    "ETA": it.eta ? dayjs(it.eta).format("YYYY-MM-DD") : "",
                    "已到/未到": it.eta ? this.calcYDWD(it.eta) : "",
                    "数量": it.amount ? it.amount : "",
                    "收货人": it.shr ? it.shr : "",
                    "备注": it.remarks ? it.remarks : "",
                };
            });
            exportExcel(list, "各地区价格明细.xlsx");
        },
        calcYDWD(eta) {
            return dayjs(eta).isAfter(dayjs()) ? "未到港" : "已到港";
        },
        selectFile(file, fileList) {
            let fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    let data = ev.target.result;
                    let workbook = xlsx.read(data, {
                        type: "binary",
                    });
                    let lines = xlsx.utils.sheet_to_json(
                        // workbook.Sheets[workbook.SheetNames[0]],
                        workbook.Sheets["25年1月到港"],
                        { header: 1 }
                    );
                    this.analyseData(lines);
                } catch (e) {
                    return;
                }
            };
            fileReader.readAsBinaryString(file.raw);
        },
        async analyseData(lines) {
            console.log('========')
            console.log(lines)
            console.log('=========')
            let result = []
            for (let i = 2; i < lines.length; i++) {
                let arr = lines[i].map(it => {
                    if (it == 0) {
                        return ""
                    } else {
                        return it
                    }
                });

                //装货时间
                let temp1 = arr[2] && arr[2] != "0" ? arr[2] : 0
                let zhsj = null
                if (temp1) {
                    let date = xlsx.SSF.parse_date_code(parseInt(temp1));
                    let temp2 = `${date.y}-${date.m}-${date.d}`; // 月份从0开始，需+1;
                    zhsj = dayjs(temp2).toDate()
                }
                //ETA
                temp1 = arr[10] && arr[10] != "0" ? arr[10] : 0
                let eta = null
                if (temp1) {
                    let date = xlsx.SSF.parse_date_code(parseInt(temp1));
                    let temp2 = `${date.y}-${date.m}-${date.d}`; // 月份从0开始，需+1;
                    eta = dayjs(temp2).toDate()
                }
                let item = {
                    scs: arr[0] && arr[0] != "0" ? arr[0] : "",
                    lyg: arr[1] && arr[1] != "0" ? arr[1] : "",
                    zhsj,
                    cm: arr[3] && arr[3] != "0" ? arr[3] : "",
                    imo: arr[4] && arr[4] != "0" ? arr[4] : "",
                    qy: arr[5] && arr[5] != "0" ? arr[5] : "",
                    sf: arr[6] && arr[6] != "0" ? arr[6] : "",
                    dhg: arr[7] && arr[7] != "0" ? arr[7] : "",
                    kq: arr[8] && arr[8] != "0" ? arr[8] : "",
                    shkmto: arr[9] && arr[9] != "0" ? arr[9] : "",
                    eta,
                    amount: arr[12] && arr[12] != "0" ? parseInt(arr[12]) : "",
                    shr: arr[13] && arr[13] != "0" ? arr[13] : "",
                    remarks: arr[14] && arr[14] != "0" ? arr[14] : "",
                }
                result.push(item)
            }
            console.log('========')
            console.log(result.sort((a, b) => a.eta.getTime() - b.eta.getTime()))
            console.log('=========')
            this.data = result
            for (let i = 0; i < this.data.length; i++) {
                let item = JSON.parse(JSON.stringify(this.data[i]));
                if (!item.zhsj) delete item.zhsj
                if (!item.eta) delete item.eta
                let res = await HttpClient.put("/restful", {
                    model: "ShipReport",
                    updates: item,
                });
                if (i < 5) {
                    console.log('========')
                    console.log(res)
                    console.log('=========')
                }
            }
            // //数据为空
            // if (
            //     lines.length < 2 ||
            //     lines[0].toString() != ["电话", "姓名", "职务"].toString()
            // ) {
            //     return this.$message.error("文件数据有误！");
            // }

            // this.loading = true;
            // let res = await HttpClient.post("/user/upload", {
            //     lines,
            // });
            // if (res) {
            //     this.$message.success("导入成功！");
            //     this.refetchData();
            // }
        },
        refetchData() {
            this.table.refetchData();
        },
        async fetchData() {
            this.loading = true
            let cond = {};
            let res = await HttpClient.post("/restful", {
                model: "ShipReport",
                cond,
                sort: {
                    eta: 1,
                },
                pageSize: this.table.pageSize,
                pageNum: this.table.pageNum,
                withCount: true,
            });
            this.data = res.result;
            this.table.submitTotal(res.count);
            this.loading = false;
            let h = {}
            this.data.forEach(it => {
                if (h[it.kq]) {
                    let is_equals = false
                    h[it.kq].forEach(it2 => {
                        if (it2 == it.shkmto) {
                            is_equals = true
                        }
                    })
                    if (!is_equals) {
                        h[it.kq].push(it.shkmto)
                    }
                } else {
                    h[it.kq] = [it.shkmto]
                }
            })
            for (let key in h) {
                if (h[key].length > 1) {
                    console.log('========')
                    console.log(h)
                    console.log('=========')
                }
            }
        },
        addOrEdit(item) {
            this.edit.addOrEdit(item);
        },
        async removeModel(item) {
            await actionConfirm();
            await removeModel("ShipReport", item._id);
            msgSuccess();
            this.refetchData();
        },
    },
};
</script>
